class PfFaqAccordion extends HTMLElement {
  constructor() {
    super();
    this.accordion = this.querySelector(".pf-faq-accordion-list-wrapper");
    this.imageWrapper = this.closest(".pf-faq-accordion-section").querySelector(
      ".media",
    );
  }

  connectedCallback() {
    // wait until the accordion height fully sets
    setTimeout(() => {
      this.setImageHeight();
    }, 500);
    window.addEventListener("resize", () => {
      this.setImageHeight();
    });
  }

  setImageHeight() {
    const accordionHeight = this.accordion.clientHeight;
    this.closest(".pf-faq-accordion-section").style.setProperty(
      "--wrapper-height",
      `${accordionHeight}px`,
    );
    this.imageWrapper.style.setProperty(
      "--wrapper-height",
      `${accordionHeight}px`,
    );
  }
}

if (!customElements.get("pf-faqaccordion")) {
  customElements.define("pf-faqaccordion", PfFaqAccordion);
}